import React from 'react';

const StarField = (props) => (
    <span className="text-danger">*</span>


);


export default StarField;